import styled from "@emotion/styled";

export const StyledFiltersSection = styled(
    "div",
    {
        shouldForwardProp(propName) {
            return propName !== "columnView";
        },
    }
)<{ columnView?: boolean }>(({ theme, columnView }) => ({
    display: "flex",
    flexDirection: columnView ? "column" : "row",
    gap: theme.spacing(columnView ? 3 : 0),
}));

export const StyledButtonsWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
}));

export const StyledFiltersWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
}));

export const StyledSideFiltersWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
    width: "100%",
}));
